"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  de: {
    com: {
      components: {
        headerCartButton: {
          cartButton: 'Warenkorb'
        }
      },
      productDetail: {
        parameters: {
          title: 'Parameter'
        }
      },
      productAvailability: {
        format: {
          available: 'lagernd',
          moreThanX: 'mehr als {min} Stück lagernd',
          exactCount: '{value} Stück lagernd',
          notAvailable: 'unverfügbar'
        }
      },
      imageGallery: {
        thumbnailsMore: '+ {number} mehr'
      },
      relatedProducts: {
        title: 'zusammenhängende Produkte'
      },
      productAccessories: {
        title: 'Zubehör'
      },
      productDetailImageGallery: {
        noImage: 'kein Bild'
      },
      productAvailabilityFieldPreviewWithPopup: {
        button: 'Wann bekomme ich die Ware?'
      }
    }
  }
};
var _default = messages;
exports.default = _default;